import { render, staticRenderFns } from "./higher-search-audiences.vue?vue&type=template&id=5c496aee&scoped=true&"
import script from "./higher-search-audiences.vue?vue&type=script&lang=js&"
export * from "./higher-search-audiences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c496aee",
  null
  
)

export default component.exports